// Bug 3 (v0.79.35) — F5 fix: /api/* travels through the parent host
// (autokvest.ru), relying on Safari's h3 (QUIC over UDP) to bypass the
// iOS Safari WebKit Networking H2 socket-tuple wedge. h3 is per-packet
// stateless (Connection ID embedded in each UDP datagram), so it has no
// socket tuple to wedge across Safari UIProcess termination.
//
// History: v0.79.34/F2 moved /api/* to api.autokvest.ru on premise P2
// («fresh origin = fresh TLS pool»). P2 falsified empirically (2026-05-03):
// wedge reproduced identically on the new subdomain. F5 routes /api/* back
// to parent because Safari's h3 Alt-Svc cache for the parent host is
// well-populated by successful static-asset responses (sw.js, /app/ HTML),
// while api.autokvest.ru never accumulated enough successful h3-eligible
// responses for Safari to enable h3 there.
//
// Empirical proof archived in commit 4a679ee message + Caddy access logs.
//
// Production AND dev both use a relative base. Prod: fetch resolves
// against the page origin (autokvest.ru). Dev: Vite's dev server proxies
// /api/* to the backend. WebSocket base stays on the parent host too —
// wsUrl() in game-api.ts uses location.host directly, no separate knob.
//
// If a future fix needs a different origin (e.g. CORS-isolated subdomain
// for a new feature), introduce a fresh conditional here at that time —
// don't resurrect the F2 hostname check, it's load-bearing for nothing.
export const API_BASE: string = '';
